import FilesView from './FilesViewContainer';
export default FilesView;
